<template>
  <div></div>
</template>

<script>
export default {
  mounted() {
    const r = confirm("logout?");
    if (!r) this.$router.go(-1);
    else this.$store.dispatch("logout", { callback: () => this.$router.go() });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";
</style>
